module.exports = __webpack_public_path__ + "img/xyphb.d85bd5de.png";